import React from 'react';
import { Alert, Button } from 'react-bootstrap';

// resultado.idCaso viene solo cuando se actualizó un caso existente (modo edición); si no, es un caso nuevo y trae el folio.
const Resultado = ({ resultado, onOtro }) => {
    const esActualizacion = resultado.idCaso !== undefined && resultado.folio === undefined;
    return (
        <div className="text-center py-5">
            <p className="mb-1">{esActualizacion ? 'Caso actualizado' : 'Caso creado'}</p>
            <p className="display-5 fw-bold text-success mb-3">Caso {esActualizacion ? resultado.idCaso : resultado.folio}</p>
            {esActualizacion
                ? <p>Los cambios quedaron guardados. El caso sigue en la bandeja de <b>{resultado.responsable}</b>.</p>
                : <p>El caso fue enviado a la bandeja de <b>{resultado.responsable}</b>.</p>}
            {resultado.cartaAdjuntada ? <p className="text-success">✔ La carta de cobro quedó adjunta.</p> : null}
            {(resultado.avisos || []).map((aviso) => <Alert key={aviso} variant="warning" className="d-inline-block">{aviso}</Alert>)}
            <div><Button variant="success" onClick={onOtro}>Ingresar otro</Button></div>
        </div>
    );
};

export default Resultado;
